const MOBILE_MEDIA_QUERY = "(max-width: 767px)";
const COMPACT_MEDIA_QUERY = "(max-width: 1023px)";

function subscribe(mediaQuery, listener) {
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener("change", listener);
    return;
  }
  mediaQuery.addListener(listener);
}

function unsubscribe(mediaQuery, listener) {
  if (mediaQuery.removeEventListener) {
    mediaQuery.removeEventListener("change", listener);
    return;
  }
  mediaQuery.removeListener(listener);
}

export default {
  data() {
    return {
      isMobileViewport: false,
      isCompactViewport: false,
    };
  },
  mounted() {
    this.__mobileMediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
    this.__compactMediaQuery = window.matchMedia(COMPACT_MEDIA_QUERY);
    this.__syncResponsiveViewport = () => {
      this.isCompactViewport = this.__compactMediaQuery.matches;
      this.isMobileViewport = this.__mobileMediaQuery.matches;
    };

    this.__syncResponsiveViewport();
    subscribe(this.__mobileMediaQuery, this.__syncResponsiveViewport);
    subscribe(this.__compactMediaQuery, this.__syncResponsiveViewport);
  },
  beforeDestroy() {
    if (!this.__syncResponsiveViewport) {
      return;
    }
    unsubscribe(this.__mobileMediaQuery, this.__syncResponsiveViewport);
    unsubscribe(this.__compactMediaQuery, this.__syncResponsiveViewport);
  },
};
